import { baseApi } from "./api";
import {
  clientGetChatsUrl,
  supportCreateTicketUrl,
  supportMyTicketsUrl,
  supportReplyUrl,
  supportSubjectsUrl,
} from "../constant/Api";

const supportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    supportCreateTicket: builder.mutation({
      query: (ticketData) => ({
        url: supportCreateTicketUrl,
        method: "POST",
        body: ticketData,
      }),
    }),

    supportSubjects: builder.query({
      query: () => ({
        url: supportSubjectsUrl,
        method: "GET",
      }),
    }),

    supportMyTickets: builder.query({
      query: ({ limit, page }) => ({
        url: `${supportMyTicketsUrl}?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    clientGetChats: builder.query({
      query: ({ ticket_id }) => ({
        url: `${clientGetChatsUrl}?ticket_id=${ticket_id}`,
        method: "GET",
      }),
    }),

    supportReply: builder.mutation({
      query: (replyData) => ({
        url: supportReplyUrl,
        method: "POST",
        body: replyData,
      }),
    }),
  }),
});

export const {
  useSupportCreateTicketMutation,
  useSupportSubjectsQuery,
  useSupportMyTicketsQuery,
  useSupportReplyMutation,
  useClientGetChatsQuery,
} = supportApi;
